import { FunctionComponent, ReactNode } from "react";

import { Nil } from "cy-util";
import { cn } from "../../../utils/cn";
export interface BasicInfoRootProps {
  className?: string;
  children: ReactNode;
}

const BasicInfoRoot: FunctionComponent<BasicInfoRootProps> = ({
  className,
  children,
}) => {
  const css = cn(
    className,
    "p-4 rounded grid gap-5 grid-cols-fill-40 sm:grid-cols-3 lg:grid-cols-4",
    // "p-4 rounded flex gap-10 flex-wrap items-center"
  );
  return <div className={css}>{children}</div>;
};

type Size = "sm" | "md";
export interface ItemProps {
  className?: string;
  label: string;
  value: string | number | Nil;
  sizeVariant?: Size;
}

const sizeCss: Record<Size, string> = {
  sm: "text-xs sm:text-sm font-light",
  md: "text-sm sm:text-base",
};
/**
 *
 */
const Item: FunctionComponent<ItemProps> = ({
  className,
  sizeVariant,
  label,
  value,
}) => {
  const css = cn(className, "");
  sizeVariant = sizeVariant || "md";
  return (
    <div className={cn(css, "text-gray-700")}>
      <div className="text-xs text-gray-500 sm:text-sm">{label}</div>
      <div className={cn(sizeCss[sizeVariant])}>{value ?? ""}</div>
    </div>
  );
};

export const BasicInfo = Object.assign(BasicInfoRoot, { Item });
